import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import * as GlobalActions from '../../../../actions/global';
import { fontWeight } from '../../../../constants/availableFonts';
import { onCssLengthChange, onThemePropChange } from '../../../helpers/ThemeStoreHelpers';
import { RemFilter } from '../../../helpers/RemFilter';
import FontConfigurator from '../../../widgets/FontConfigurator/FontConfigurator';
import CSSLength from '../../../../../lib/css-property-parser/CSSLength';

const prefix = 'global';

const FontPropertyInput = ({ label, values, defaultValue, onChange, isDisabled }) => {
    return (
        <div className="col-xs-12 col-sm-4">
            <ReactSparkSelectInput
                label={label}
                onChange={onChange}
                isDisabled={isDisabled}
                defaultValue={defaultValue}
                values={values.map(v => {
                    return { key: v.toString(), label: v.toString() };
                })}
            />
        </div>
    );
};

class BodyStyles extends Component {
    render() {
        const fontSize1 = new CSSLength(this.props.fontData.baseSize, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const fontSize2 = fontSize1.px;
        const fontSize3 = Math.round(fontSize2.substring(0, fontSize2.length - 2)) + 'px';
        let smallerSizeFilter = new RemFilter(this.props.fontData.smallerSize);
        const fontThinBoldWeights = [100, 200, 300, 400, 500, 600, 700, 800, 900];
        return (
            <div className="GlobalStyles">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12 col-sm-5">
                        <div className="row">
                            <div className="col-lg-12 col-xs-12 col-sm-8">
                                <FontConfigurator
                                    fontFamilyLabel="Main Font"
                                    fontFamilyProperty="global.font.main"
                                    fontFamilyClass="col-xs"
                                />
                            </div>
                            <FontPropertyInput
                                label="Base Size"
                                defaultValue={fontSize3}
                                isDisabled={this.props.isDisabled}
                                values={this.props.availableFontSizes}
                                onChange={this.props.onFontSizeChange(this.props.tagName)}
                            />
                            <FontPropertyInput
                                label="Smaller Size"
                                defaultValue={smallerSizeFilter.original.px.toString()}
                                isDisabled={this.props.isDisabled}
                                values={this.props.availableFontSizes}
                                onChange={this.props.onCssLengthChange('font.smallerSize', smallerSizeFilter)}
                            />
                            <FontPropertyInput
                                label="Font Weight"
                                defaultValue={this.props.fontData.normalWeight}
                                values={fontWeight}
                                isDisabled={this.props.isDisabled}
                                onChange={this.props.onFontWeightChange(this.props.tagName)}
                            />
                            <FontPropertyInput
                                label="Bold"
                                defaultValue={this.props.fontData.bold}
                                values={fontThinBoldWeights}
                                isDisabled={this.props.isDisabled}
                                onChange={this.props.onThemePropChange('font.bold')}
                            />

                            {this.props.tagName !== 'smallBody' ? (
                                <FontPropertyInput
                                    label="Text-Transform"
                                    defaultValue={this.props.fontData.textTransform}
                                    isDisabled={this.props.isDisabled}
                                    values={['uppercase', 'lowercase', 'capitalize', 'none']}
                                    onChange={this.props.onTextDecorationChange(this.props.tagName)}
                                />
                            ) : null}

                            <FontPropertyInput
                                label="Line Height"
                                defaultValue={this.props.fontData.lineHeight}
                                isDisabled={this.props.isDisabled}
                                values={this.props.availableLineHeight}
                                onChange={this.props.onLineHeightChange(this.props.tagName)}
                            />

                            <div className="spark-panel__content">
                                <div className="row">
                                    <div className="ThemeColorRow col-lg-2 col-sm-1">
                                        Color
                                        <PresetColorPicker
                                            color={this.props.fontData.color}
                                            isDisabled={this.props.isDisabled}
                                            onColorChange={this.props.onFontColorChange(this.props.tagName)}
                                        />
                                    </div>
                                    <div className="ThemeColorRow col-lg-2 col-sm-1">
                                        Alternate
                                        <PresetColorPicker
                                            color={this.props.fontData.colorAlternate}
                                            isDisabled={this.props.isDisabled}
                                            onColorChange={this.props.onThemePropChange('font.colorAlternate')}
                                        />
                                    </div>
                                    <div className="ThemeColorRow col-lg-2 col-sm-1">
                                        Highlight
                                        <PresetColorPicker
                                            color={this.props.fontData.colorHighlight}
                                            isDisabled={this.props.isDisabled}
                                            onColorChange={this.props.onThemePropChange('font.colorHighlight')}
                                        />
                                    </div>
                                    <div className="ThemeColorRow col-lg-2 col-sm-1">
                                        Light
                                        <PresetColorPicker
                                            color={this.props.fontData.colorLight}
                                            isDisabled={this.props.isDisabled}
                                            onColorChange={this.props.onThemePropChange('font.colorLight')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-2"></div>
                    <div className="col-xs-12 col-sm-3">
                        <p
                            style={{
                                fontFamily: this.props.fontData.main,
                                lineHeight: this.props.fontData.lineHeight,
                                color: this.props.fontData.color,
                                fontWeight: this.props.fontData.normalWeight,
                                fontSize: fontSize3
                            }}
                        >
                            {this.props.sampleText}
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

BodyStyles.propTypes = {
    children: PropTypes.element,
    settings: PropTypes.object,
    tagNameName: PropTypes.string,
    sampleText: PropTypes.string.isRequired
};

const mapStateToProps = state => {
    return { ...state.theme.global };
};

const mapDispatchToProps = dispatch => {
    return {
        onFontChange: tagName => {
            return event => dispatch(ThemeActions.setGlobalFont(tagName, event.target.value));
        },
        onFontSizeChange: tagName => {
            return event => dispatch(GlobalActions.setGlobalFontSize(tagName, event.target.value));
        },
        onFontWeightChange: tagName => {
            return event => dispatch(GlobalActions.setGlobalFontWeight(tagName, event.target.value));
        },
        onFontColorChange: tagName => {
            return event => dispatch(GlobalActions.setGlobalFontColor(tagName, event.target.value));
        },
        onFontStyleChange: tagName => {
            return event => dispatch(GlobalActions.setGlobalFontStyle(tagName, event.target.value));
        },
        onTextDecorationChange: tagName => {
            return event => dispatch(GlobalActions.setTextDecoration(tagName, event.target.value));
        },
        onLineHeightChange: tagName => {
            return event => dispatch(GlobalActions.setLineHeight(tagName, event.target.value));
        },
        onTextAlignChange: tagName => {
            return event => dispatch(GlobalActions.setTextAlignment(tagName, event.target.value));
        },
        onThemePropChange: onThemePropChange(dispatch, prefix),
        onCssLengthChange: onCssLengthChange(dispatch, prefix)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BodyStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/global/BodyStyles.js